<template>
    <div class="body-block">
        <div v-if="showCaptcha">
            <captcha-control :instance="locationId" force-external></captcha-control>
            <div class="uk-alert uk-alert-warning" uk-alert>
                <p>Caution: For information on why you are being asked this, <a href="/why-we-limit-access">please click here</a>.</p>
            </div>
        </div>
        <div v-if="isBlocked">
            <div class="uk-alert uk-alert-danger" uk-alert>
                <p>Error: your activity has been restricted.  For information on why we impose limits, <a href="/why-we-limit-access">please click here</a>.</p>
            </div>
        </div>

        <div v-if="!showCaptcha && !isBlocked">
            <div v-if="show.phone" class="phone">
                <strong>Phone:</strong>

                <a v-if="!shouldShowPhone" href="#" @click.prevent="displayPhoneNumbers($event)" class="phone">Click to Show</a>
                <span v-if="shouldShowPhone">{{ phoneNumbers.phone }}</span>
            </div>
            <div v-if="show.fax" class="fax">
                <strong>Fax:</strong>

                <a v-if="!shouldShowFax" href="#" @click.prevent="displayPhoneNumbers($event)" class="fax">Click to Show</a>
                <span v-if="shouldShowFax">{{ phoneNumbers.fax }}</span>
            </div>
            <div v-if="show.afterHours" class="after-hours">
                <strong>After Hours:</strong>

                <a v-if="!shouldShowAfterHours" href="#" @click.prevent="displayPhoneNumbers($event)" class="afterhours">Click to Show</a>
                <span v-if="shouldShowAfterHours">{{ phoneNumbers.afterHours }}</span>
            </div>
            <div v-if="show.tollFree" class="toll-free">
                <strong>Toll Free:</strong>

                <a v-if="!shouldShowTollFree" href="#" @click.prevent="displayPhoneNumbers($event)" class="tollfree">Click to Show</a>
                <span v-if="shouldShowTollFree">{{ phoneNumbers.tollFree }}</span>
            </div>
            <div v-if="showWarning">
                <div class="uk-alert uk-alert-warning" uk-alert>
                    <p>Caution: your activity is approaching the limits for your access.  For information on why we impose limits, <a href="/why-we-limit-access">please click here</a>.</p>
                </div>
            </div>
        </div>
    </div>
</template>


<script>import script from './CallControl';
    export default script;</script>

<style lang="less" scoped>
    /* since this is a custom element this will not be compiled into a css file but will be a part of the elements styling */
    a {
        color: #c55806;
        text-decoration: none;
        cursor: pointer;
    }

        a:hover {
            color: #f87d20;
            text-decoration: underline;
        }
</style>
